import MultiField from 'Components/Forms/MultiField';
import React from 'react';

const StepList = ({ steps, push, remove, move }) => {
  return (
    <MultiField
      name="steps"
      values={steps}
      push={push}
      remove={remove}
      move={move}
      label="What steps will be used?"
      placeholder="Add new step"
      suggestions={[]}
      isSortable={true}
      valueKey="description"
    />
  );
};

export default StepList;
